/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectKeyDTO
 */
export interface ProjectKeyDTO {
    /**
     * 
     * @type {string}
     * @memberof ProjectKeyDTO
     */
    proposal: string;
}

/**
 * Check if a given object implements the ProjectKeyDTO interface.
 */
export function instanceOfProjectKeyDTO(value: object): value is ProjectKeyDTO {
    if (!('proposal' in value) || value['proposal'] === undefined) return false;
    return true;
}

export function ProjectKeyDTOFromJSON(json: any): ProjectKeyDTO {
    return ProjectKeyDTOFromJSONTyped(json, false);
}

export function ProjectKeyDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectKeyDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'proposal': json['proposal'],
    };
}

export function ProjectKeyDTOToJSON(value?: ProjectKeyDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'proposal': value['proposal'],
    };
}

